<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
       <el-breadcrumb separator-class="el-icon-arrow-right">
           <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Supplier/index.html')">供应商管理</div></el-breadcrumb-item>
           <el-breadcrumb-item>供应商管理</el-breadcrumb-item>
       </el-breadcrumb>

        <el-form :inline="true" :model="item" class="search">
            <el-row>
                <el-form-item label="供应商状态">
                    <el-radio-group v-model="item.auth_status" @change="submit">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="10">审核中</el-radio-button>
                        <el-radio-button label="1">已通过</el-radio-button>
                        <el-radio-button label="2">被驳回</el-radio-button>
                        <el-radio-button label="20">已冻结</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="供应商名称">
                    <el-input v-model="item.name" placeholder=""
                              size="small"></el-input>
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="item.mobile" placeholder="请输入手机号码"
                              size="small"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit" size="medium">查询</el-button>
                </el-form-item>
            </el-row>
        </el-form>
        <div class="btns">
            <el-button type="primary" size="small" @click="add" v-auth="['admin/supplier/add']">添加供应商</el-button>
            <el-button type="danger" size="small" @click="delAll" v-auth="['admin/supplier/delete']">批量冻结</el-button>
        </div>

        <!--		数据是list 通过list展示-->
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * limit + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="company_name" label="公司名称"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="mobile" label="手机号码"></el-table-column>
            <el-table-column prop="legal_person" label="法人姓名"></el-table-column>
            <el-table-column prop="fee" width="160" align="center" label="短信/技术服务费比例">
                <template slot-scope="scope">
                    {{scope.row.sms_fee}}%/ {{scope.row.service_fee}}%
                </template>
            </el-table-column>
            <el-table-column prop="legal_person" label="法人姓名"></el-table-column>
            <el-table-column label="状态">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.status == 1">
                        激活
                    </el-tag>
                    <el-tag size="small" type="danger" v-else>
                        冻结
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="审核状态">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.auth_status == 1">
                        已通过
                    </el-tag>
                    <el-tag size="small" type="danger" v-if="scope.row.auth_status == 2">
                        被驳回
                    </el-tag>
                    <el-tag size="small" type="danger" v-if="scope.row.auth_status == 10">
                        审核中
                    </el-tag>
                    <el-tag size="small" type="danger" v-if="scope.row.auth_status == 0">
                        待提交
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="320">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/supplier/update']">编辑</el-button>
                    <el-button size="mini" type="primary" @click="view(scope.row.id)" v-if="scope.row.auth_status == 10" v-auth="['admin/supplier/audit']">审核</el-button>
                    <el-button size="mini" type="primary" @click="view(scope.row.id)" v-if="scope.row.auth_status != 0 && scope.row.auth_status != 10" v-auth="['admin/supplier/audit']">查看</el-button>
                    <el-popconfirm title="您确定要冻结这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-if="scope.row.status == 1" v-auth="['admin/supplier/add']">
                        <el-button size="mini" type="danger" slot="reference">冻结</el-button>
                    </el-popconfirm>
					<div style="display: inline-block;" v-else>
						<el-popconfirm title="您确定要解冻这条数据吗？" @confirm="jiedong(scope.row.id)" class="l10" v-auth="['admin/supplier/jiedong']">
							<el-button size="mini" type="danger" slot="reference">解冻</el-button>
						</el-popconfirm>
						<el-popconfirm title="您确定要删除吗？" @confirm="realdel(scope.row.id)" class="l10" v-auth="['admin/supplier/jiedong']">
							<el-button size="mini" type="danger" slot="reference">删除</el-button>
						</el-popconfirm>
					</div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                // 展示数据
                list: [],
                isLoad: false,
				pageNum: 0,
                limit: 20,
                total: 0,
                page: 1,
                number: 0,
                // 查询
                item: {
                    auth_status: '0'
                },
                optionsName:[]
            }
        },
        created() {
			this.item = {
                page: this.page,
                limit: this.limit,
                auth_status: 10
            },
            this.loadList()
            this.getData()
        },
        methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
            getData(){
                // this.axios.post('/admin/supplier/list', {
                // }).then(res => {
                //     res.data.list.forEach((item) => {
                //         this.optionsName.push(item)
                //     })
                // })
            },
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/supplier/list', this.item)
                .then(res => {
                    this.isLoad = false
                    this.list = res.data.list.data
                    this.total = res.data.list.total

                })
                .catch(() => {
                    this.isLoad = false
                })
            },
            add() {
                this.$router.push({path: '/Supplier/edit.html'});
            },
            edit(id) {
                this.$router.push({
                    path: '/Supplier/edit.html',
                    query: {
                        id: id
                    }
                });
            },
            view(id) {
                this.$router.push({
                    path: '/Supplier/view.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/supplier/delete', {
                    data: [
                        id
                    ]
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '冻结成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            jiedong(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/supplier/jiedong', {
                    data: [
                        id
                    ]
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '解冻成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
			//删除
			realdel(id) {
			    if (this.isLoad) {
			        return
			    }
			    this.isLoad = !this.isLoad
			    this.axios.delete('/admin/supplier/delete', {
			        data: [
			            id
			        ]
			    })
			    .then(() => {
			        this.isLoad = !this.isLoad
			        this.$message.success({
			            message: '删除成功',
			            showClose: false
			        });
			        this.loadList()
			    })
			    .catch(() => {
			        this.isLoad = !this.isLoad
			    })
			},
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/supplier/delete', {
                    data: id
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '冻结成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            sizeReload(val) {
                this.item.limit = val
                this.loadList()
            },
            pageReload(val) {
                this.item.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
				this.pageNum = 1
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                return;
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/Member/excelOut', {
                    params: {
                        nickname: this.item.nickname,
                        title: this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>
